import React from 'react';
import { useLocation } from 'react-router-dom';

const mercadoPagoQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const getIsMercadoPagoErrorSearchParam = (): boolean => {
  const query = mercadoPagoQuery();
  const isMercadoPagoErrorString = query.get('isMercadoPagoError');
  const isMercadoPagoError = isMercadoPagoErrorString === 'true';

  return isMercadoPagoError;
};

export default getIsMercadoPagoErrorSearchParam;
